import { useCallback, useRef, useMemo, useEffect } from 'react';
import debounce from 'lodash/debounce';

const useDebouncedFetch = (fetchFn, delay = 400) => {
    const abortControllerRef = useRef(null);

    const fetchWithAbort = useCallback(async (...args) => {
        // Отменяем предыдущий запрос
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        abortControllerRef.current = new AbortController();

        try {
            await fetchFn(...args, abortControllerRef.current.signal);
        } catch (err) {
            if (err.name === 'CanceledError' || err.code === 'ERR_CANCELED') return;
            throw err;
        }
    }, [fetchFn]);

    const debouncedFetch = useMemo(
        () => debounce(fetchWithAbort, delay),
        [fetchWithAbort, delay]
    );

    // Очистка при размонтировании
    useEffect(() => {
        return () => {
            debouncedFetch.cancel();
            abortControllerRef.current?.abort();
        };
    }, [debouncedFetch]);

    return { debouncedFetch, abortControllerRef };
};

export default useDebouncedFetch;